import React from "react";
import { Platform, StyleSheet, Text, View } from "react-native";

import * as PlatformUtils from "../modules/platformUtils";
import { Typography } from "./styles/typography";
import colours from "./styles/colours";
import { BorderRadius, Spacing } from "./styles/number";

export interface OrderStatusLabelProps {
  bgColor: string;
  title: string;
}

const style = (bgColor: string) =>
  StyleSheet.create({
    container: {
      backgroundColor: bgColor,
      borderRadius: BorderRadius.Medium,
      paddingHorizontal: Spacing.Thin,
    },
    label: {
      ...Typography.badgeText,
      fontSize: 13,
      lineHeight: 20,
      color: colours.darkGrey,
    },
  });

const OrderStatusLabel: React.FC<OrderStatusLabelProps> = (props) => {
  const { bgColor, title } = props;

  return (
    <View
      style={style(bgColor).container}
      {...PlatformUtils.generateTestID(Platform.OS, "orderStatusLabel")}>
      <Text style={style(bgColor).label}>
        {title ? title.toUpperCase() : ""}
      </Text>
    </View>
  );
};

export default OrderStatusLabel;
